import { TRADE_GROUP_WORDS, tradeGroups, type TradeDto } from '@nsb/core';

/**
 * A trade picker's options, in the one order every list of trades has (L-15, Jason, 2026-10-07: "put organizational
 * custom trades at the top, then key trades then the rest"; core `tradeGroups`): NSB's own, the key trades, then every
 * other, each group in CSI order with its number. An archived trade shows only when it is the one already chosen.
 */
export function TradeOptions({ trades, current }: { trades: readonly TradeDto[]; current: string | null | undefined }) {
  const live = trades.filter((t) => !t.archived || t.key === current);
  const label = (t: TradeDto) => `${t.csi ? `${t.csi} · ` : ''}${t.name}`;
  return (
    <>
      {tradeGroups(live).map((g) => (
        <optgroup key={g.group} label={TRADE_GROUP_WORDS[g.group]}>
          {g.trades.map((t) => (
            <option key={t.key} value={t.key}>
              {label(t)}
            </option>
          ))}
        </optgroup>
      ))}
    </>
  );
}
